<script>
import Multiselect from 'vue-multiselect';

const CONVERSATION_TYPES = [
  { id: 'all', name: 'All' },
  { id: 'agent', name: 'Agent' },
  { id: 'bot', name: 'Bot' },
];

export default {
  components: { Multiselect },
  emits: ['conversationTypeFilterSelection'],
  data() {
    return {
      conversationTypes: CONVERSATION_TYPES,
      selectedConversationType: CONVERSATION_TYPES[0],
    };
  },
  methods: {
    handleInput(selectedType) {
      this.$emit('conversationTypeFilterSelection', selectedType);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <Multiselect
      v-model="selectedConversationType"
      track-by="id"
      label="name"
      class="no-margin"
      :placeholder="$t('CSAT_REPORTS.FILTERS.CONVERSATION_TYPE.PLACEHOLDER')"
      :show-labels="false"
      :max-height="160"
      :options="conversationTypes"
      :allow-empty="false"
      :option-height="24"
      @update:model-value="handleInput"
    />
  </div>
</template>
